import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseRepository } from '../Common/Data/base.repository';

export interface ClientPaymentApproverCandidatesRequest {
    paymentIds?: number[];
    taskIds?: number[];
    includeAllCompanyContacts?: boolean;
}

export interface ClientPaymentApproverCandidate {
    contactId: number;
    firstName?: string;
    lastName?: string;
    displayName: string;
}

export interface ClientPaymentApproverCandidatesResponse {
    candidates: ClientPaymentApproverCandidate[];
}

@Injectable({ providedIn: 'root' })
export class PaymentRepository extends BaseRepository {
    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    getClientPaymentApproverCandidates(
        request: ClientPaymentApproverCandidatesRequest,
    ): Observable<ClientPaymentApproverCandidatesResponse> {
        return this.httpPost('/api/payment/client-approver/candidates', request);
    }
}
